"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Balcony = function Balcony() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M12 2C8.68629 2 6 4.68629 6 8V14H2C1.44772 14 1 14.4477 1 15C1 15.5523 1.44772 16 2 16H3V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V16H22C22.5523 16 23 15.5523 23 15C23 14.4477 22.5523 14 22 14H18V8C18 4.68629 15.3137 2 12 2ZM8 7.99999C8 6.13615 9.27477 4.57005 11 4.12601V7.99999H8ZM8 14V9.99999H11V14H8ZM13 14H16V9.99999H13V14ZM13 7.99999H16C16 6.13615 14.7252 4.57005 13 4.12601V7.99999ZM5 16.5C5 16.2239 5.22386 16 5.5 16H6.5C6.77614 16 7 16.2239 7 16.5V19.5C7 19.7761 6.77614 20 6.5 20H5.5C5.22386 20 5 19.7761 5 19.5V16.5ZM9.5 16C9.22386 16 9 16.2239 9 16.5V19.5C9 19.7761 9.22386 20 9.5 20H10.5C10.7761 20 11 19.7761 11 19.5V16.5C11 16.2239 10.7761 16 10.5 16H9.5ZM13 16.5C13 16.2239 13.2239 16 13.5 16H14.5C14.7761 16 15 16.2239 15 16.5V19.5C15 19.7761 14.7761 20 14.5 20H13.5C13.2239 20 13 19.7761 13 19.5V16.5ZM17.5 16C17.2239 16 17 16.2239 17 16.5V19.5C17 19.7761 17.2239 20 17.5 20H18.5C18.7761 20 19 19.7761 19 19.5V16.5C19 16.2239 18.7761 16 18.5 16H17.5Z",
    fill: "#75767A"
  }));
};
var _default = Balcony;
exports.default = _default;